import React from 'react';
import newsLetter from '../../img/newsletter.png';

const Newsletter = () => {
    return (
        <div className='md:px-12 mt-8 md:mt-14'>
            <img className='h-52 md:mb-[-40px] mb-[-50px] lg:mb-[-34px] lg:mx-0 mx-auto md:pl-16' src={newsLetter} alt="" />

            <div className='bg-green-100 lg:flex md:px-12 md:mx-12 mx-4 h-44 rounded-t-3xl' >
                <div className='flex-1 mt-8 pt-4 pl-2'>
                    <h1 className='text-2xl mb-1 font-semibold text-center lg:text-left'>Newsletter</h1>
                    <h4 className='text-center lg:text-left'>Subscribe and get notification from us</h4>
                </div>
                <div className='flex-1 lg:mt-14 mt-6 ml-3 md:ml-4 lg:ml-2'>
                    <input type="email" placeholder='Email Address*' className='input focus:outline-none md:w-72' />
                    <button className='ml-2 px-2 md:px-8 py-3 bg-green-500 text-white rounded-xl'>Subscribe</button>
                </div>
            </div>
            {/* <div className='bg-black h-12'></div> */}
        </div>
    );
};

export default Newsletter;